import templateUrl from './listview-pagination.tpl.html';

angular
    .module('festzelt-os.components')
    .component('listviewPagination', {
        bindings: {
            store: '=',
        },
        controller() {
            this.$onInit = () => {
            }
        },
        controllerAs: 'vm',
        templateUrl: templateUrl
    });



// WEBPACK FOOTER //
// ./src/app/components/state-manager/listview/pagination/listview-pagination.js